import './ContractPage.less';
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';

import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import ContractPageForm from './ContractPageForm/ContractPageForm';
import Button, {BUTTON_STYLE} from '../../../../shared-components/Button/Button';
import { ENSIGHTEN_APP_APPROVED } from '../../../../framework/store/Ensighten/EnsightenConstants';
import { triggerEnsightenEvent } from '../../../../framework/store/Ensighten/EnsightenActions';
import AnnouncementPopup from '../../../../shared-components/AnnouncementPopup/AnnouncementPopup';
import { APPROVAL_POPUP, CONFIRM_POPUP} from './ContractPageForm/ContractPageFormConstants';
import { setApprovalPopUp } from './ContractPageForm/ContractPageFormActions';
import { CONTRACT_FORM_ID } from '../../../../framework/App/AppConstants';
const LOCALE_PREFIX = 'DE/pages/ContractPage/ContractPage';

export class ContractPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        onCloseApprovalPopup: PropTypes.func.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
        onClickConfirmPopUp: PropTypes.func.isRequired,
        onCancelConfirmPopup: PropTypes.func.isRequired,
        popUpName: PropTypes.string
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    handleCloseApprovalPopup = event => {
        return this.props.onCloseApprovalPopup(event);
    };

    handleClickConfirmPopup = event => {
        return this.props.onClickConfirmPopUp(event);
    };

    handelCancelConfirmPopup = event => {
        return this.props.onCancelConfirmPopup(event);
    };

    render() {
        const { intl, popUpName } = this.props;
        let announcementPopUpContent;
        let announcementPopUpContent2;
        let announcementPopUPFooter;
        let showX;
        let onHide;

        if (popUpName === APPROVAL_POPUP) {
            announcementPopUpContent = (
                <h2 className="alpha">{intl.formatMessage({ id: `${LOCALE_PREFIX}.approvedPopUpHeader` })}</h2>
            );
            announcementPopUPFooter = (
                <div id="action-buttons" className="buttons">
                    <Button
                        data-automation-id="closeApprovedPopUp"
                        btnStyle={BUTTON_STYLE.PP_PRIMARY}
                        className="closeApprovedPopUp"
                        id="closeApprovedPopUp"
                        name="closeApprovedPopUp"
                        tabIndex="0"
                        onClick={this.handleCloseApprovalPopup}
                    >{intl.formatMessage({ id: `${LOCALE_PREFIX}.approvedPopUpButton` })}</Button>
                </div>
            );
            showX = false;
        } else if (popUpName === CONFIRM_POPUP) {

            announcementPopUpContent = (<h2 className="alpha">{intl.formatMessage({ id: `${LOCALE_PREFIX}.wannaContinue` })}</h2>);
            announcementPopUpContent2 = intl.formatMessage({id: `${LOCALE_PREFIX}.areYouSure`});
            announcementPopUPFooter = (
                <div id="action-buttons" className="buttons">
                    <Button
                        data-automation-id="bmlAgreeToTermsSubmit"
                        className="bmlAgreeToTerms trackButtonAndLinkClick"
                        btnStyle={BUTTON_STYLE.PP_PRIMARY}
                        id="bmlAgreeToTermsSubmit"
                        name="bmlAgreeToTermsSubmit"
                        tabIndex="0"
                        onClick={this.handleClickConfirmPopup}
                    >{intl.formatMessage({ id: `${LOCALE_PREFIX}.areYouSureContinue` })}</Button>
                </div>
            );
            showX = true;
            onHide = this.handelCancelConfirmPopup;
        }
        return (
            <div className="outerWrapper de-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="ContractPage">
                            <Header singleColumnLayout={true} msg={intl.formatMessage({id: `${LOCALE_PREFIX}.contractPageTitle`})} />
                            <div id="content">
                                <div id="content-child" className="container row-fluid table-layout">
                                    <section className="contentSection">
                                        <ContractPageForm />
                                    </section>
                                </div>
                                {popUpName && (
                                    <AnnouncementPopup
                                        id={popUpName}
                                        footer={announcementPopUPFooter}
                                        showXButton={showX}
                                        stickyFooter={false}
                                        showPPLogo={false}
                                        onClose={onHide}
                                    >
                                        {announcementPopUpContent}
                                        {announcementPopUpContent2}
                                    </AnnouncementPopup>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        popUpName: _.get(state, 'contractPageForm.currentPopUpName')
    };
};

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_contractpage', 'prepare_pp_credit_contractpage'));
        dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_APPROVED));
    },
    onCloseApprovalPopup(e) {
        dispatch(setApprovalPopUp(''));
    },
    onClickConfirmPopUp(e) {
        dispatch(submit(CONTRACT_FORM_ID));
    },
    onCancelConfirmPopup(e) {
        dispatch(setApprovalPopUp(''));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ContractPage));
